export default __webpack_public_path__ + "static/media/a018-10.dd1d9df1.svg";